// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';
import { Route, Switch, Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import Banner from '../../../elements/Banner/Banner';
import PaymentsMadeContainer from '../containers/PaymentsMadeContainer';
import PaymentsReceivedContainer from '../containers/PaymentsReceivedContainer';
import Page from '../../../Page';
import routes from '../../../routes';

import style from './Payments.scss';
import subNavStyle from '../../../assets/styles/sub-nav.scss';

type Props = {
  +location: {
    pathname: string;
  };
};

export default class Payments extends Component<Props, void> {

  render() {
    const { location } = this.props;
    const subRoute = location.pathname.split('/')[2];
    return [
      <Banner key="banner" translatedId="payments.header.title" color="blue"/>,
      <nav key="nav" className={classNames(subNavStyle.subNav, style.subNav)}>
        <section>
          <ul>
            <li className={classNames({ [subNavStyle.active]: subRoute === 'made' })}>
              <FormattedMessage id="payments.nav.made">{
                txt => (<Link to="/my-payments/made">{txt}</Link>)
              }</FormattedMessage>
            </li>
            <li className={classNames({ [subNavStyle.active]: subRoute === 'received' })}>
              <FormattedMessage id="payments.nav.received">{
                txt => (<Link to="/my-payments/received">{txt}</Link>)
              }</FormattedMessage>
            </li>
          </ul>
        </section>
      </nav>,
      <Switch key="switch">
        <Redirect from="/my-payments" exact to="/my-payments/made"/>
        <Route exact path={routes.MY_PAYMENTS.children.MADE.routePath}
               render={props => <Page name={routes.MY_PAYMENTS.children.MADE.name}>
                 <PaymentsMadeContainer {...props}/>
               </Page>}/>
        <Route exact path={routes.MY_PAYMENTS.children.RECEIVED.routePath}
               render={props => <Page name={routes.MY_PAYMENTS.children.RECEIVED.name}>
                 <PaymentsReceivedContainer {...props}/>
               </Page>}/>
      </Switch>
    ];
  }
}

Payments.propTypes = {
  location: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/payments/components/Payments.jsx